import React, { useEffect, useState } from 'react'
import Page from 'shared/types/Page'
import { NavLink } from "react-router-dom"
import useInit from './hooks/useInit'
import SubMenu from 'shared/components/SubMenu'
import getPageByPath from 'shared/utils/getPageByPath'

interface MenuItemProps {
    label: string,
    link: string,
    icon?: any,
    iconActive?: any,
    isActive?: boolean,
    pages?: Page[],
    currentPage: Page | null
    setCurrentPage?: Function
    id?: number | string
}

const MenuItem: React.FunctionComponent<MenuItemProps> = (props) => {
    
    const [subMenuPages, setSubMenuPages] = useState<any>([])
    const [activeClass, setActiveClass] = useState<any>('')
    const [icon, setIcon] = useState<any>('')
    
    useInit({
        setSubMenuPages,
        setActiveClass,
        setIcon,
        curLink: props.link,
        curIcon: props.icon,
        curIconActive: props.iconActive,
        isActive: props.isActive,
        pages: props.pages,
        curPage: props.currentPage
    })
    
    return (
        <li className="menu-item">
            <NavLink
                to={props.link}
                className={"nav-link" + activeClass}
                onClick={() => {
                    if (props.setCurrentPage) {
                        const page = getPageByPath(props.link, props.pages)
                        props.setCurrentPage(page)
                    }
                }}
            >
                {icon}
                <span>{props.label}</span>
            </NavLink>
            {subMenuPages.length > 0 ? <SubMenu pages={subMenuPages} currentPage={props.currentPage} setCurrentPage={props.setCurrentPage} /> : ''}
        </li>
    );
}

export default MenuItem;